(() => {
  'use strict';
  const config=document.querySelector('[data-spqr-cart-offer-config]');
  if(!config || window.Shopify?.designMode) return;
  const endpoint=config.dataset.endpoint;
  const storageKey='spqr-cart-offer-standard-rings-2026-09';
  const root=window.Shopify?.routes?.root || '/';
  let saved, active, inFlight, dismissed=false, toastArmed=false, expiredHandled=false, clockOffset=0; // toastArmed: the modal opens only after an add on this page, never on page load
  try {
    saved=JSON.parse(localStorage.getItem(storageKey) || 'null') || {visitor:crypto.randomUUID()};
    if(!/^[a-zA-Z0-9-]{20,80}$/.test(saved.visitor || '')) saved={visitor:crypto.randomUUID()};
    localStorage.setItem(storageKey,JSON.stringify(saved));
  } catch {return;} // Persistent storage is needed to preserve the original offer window.
  const persist=()=>{try{localStorage.setItem(storageKey,JSON.stringify(saved));}catch{}};
  const panels=[];
  function panel(toast) {
    const box=document.createElement(toast?'dialog':'aside');
    box.className='spqr-cart-offer'+(toast?' spqr-cart-offer--modal':'');if(!toast)box.hidden=true;
    box.setAttribute('aria-label','Five-minute cart offer');
    box.innerHTML='<div class="spqr-cart-offer__top"><span class="spqr-cart-offer__title">Extra 10% off unlocked</span><span class="spqr-cart-offer__timer" role="timer" aria-live="off">05:00</span></div><p data-offer-copy>Complete your order before the timer ends.</p>';
    if(toast) {
      const close=document.createElement('button');close.type='button';close.className='spqr-cart-offer__close';close.setAttribute('aria-label','Dismiss offer notification');close.textContent='×';
      close.addEventListener('click',()=>{dismissed=true;box.close();});box.append(close);box.addEventListener('cancel',()=>{dismissed=true;});
      const link=document.createElement('a');link.className='spqr-cart-offer__action';link.href=root+'checkout';link.textContent='Checkout with 10% off';
      box.append(link);
      const status=document.createElement('span');status.className='visually-hidden';status.setAttribute('role','status');status.dataset.offerAnnouncement='';box.append(status);
    }
    panels.push({box,toast});return box;
  }
  document.body.append(panel(true));
  function mount() {
    for(const form of document.querySelectorAll('#CartDrawerForm,#CartPageForm')) {
      if(form.querySelector('.spqr-cart-offer')) continue;
      const position=form.querySelector('.cart__checkout-wrapper');
      if(position) position.before(panel(false));
    }
  }
  const currentTime=()=>Date.now()+clockOffset;
  function render() {
    mount();
    const seconds=active?Math.max(0,Math.ceil((active.expiresAt-currentTime())/1000)):0;
    for(const {box,toast} of panels) {
      const visible=!!active && seconds>0 && !(toast&&(dismissed||!toastArmed));
      if(toast) {if(visible&&!box.open)box.showModal();else if(!visible&&box.open)box.close();}
      else box.hidden=!visible;
      if(seconds) box.querySelector('[role="timer"]').textContent=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');
    }
    if(active && !seconds && !expiredHandled) {
      expiredHandled=true;const code=active.code;active=null;saved.expired=true;persist();
      removeCode(code).catch(()=>{}); // Shopify's endsAt also enforces expiry in checkout.
    }
  }
  async function cart() {
    const r=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!r.ok) throw new Error('Cart unavailable');return r.json();
  }
  function codes(data) {
    return (data.discount_codes || []).map(d=>typeof d==='string'?d:d.code).filter(Boolean);
  }
  async function setCodes(list) {
    const r=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:[...new Set(list)].join(',')})});
    if(!r.ok) throw new Error('Discount unavailable');return r.json();
  }
  async function removeCode(code) {
    const current=await cart();const list=codes(current);
    if(list.some(c=>c.toUpperCase()===code.toUpperCase())) {await setCodes(list.filter(c=>c.toUpperCase()!==code.toUpperCase()));document.dispatchEvent(new CustomEvent('cart:build'));}
  }
  async function start(showToast=false) {
    if(inFlight) return inFlight;
    inFlight=(async()=>{
      if(saved.expired) return;
      const current=await cart();
      if(!current.item_count) {active=null;render();return;}
      // The offer starts on the 3rd item (fees like engraving excluded), so it never interrupts building a multi-item order.
      const items=(current.items||[]).filter(i=>i.product_type!=='Fee'&&!i.gift_card).reduce((n,i)=>n+i.quantity,0);
      if(!saved.code && items<3) {active=null;render();return;}
      let response,data;
      for(let attempt=0;attempt<3;attempt++) {
        response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({visitor:saved.visitor,cart:current.token}),signal:AbortSignal.timeout(15000)});
        data=await response.json();
        if(data.status!=='pending') break;
        await new Promise(resolve=>setTimeout(resolve,1200));
      }
      if(data.status==='expired') {saved.expired=true;persist();active=null;render();if(saved.code)await removeCode(saved.code);return;}
      if(!response.ok || data.status!=='active' || !/^SPQR5-[A-F0-9]{24}$/.test(data.code) || !Number.isFinite(data.expiresAt) || !Number.isFinite(data.serverTime)) return;
      clockOffset=data.serverTime-Date.now();
      // Save even if cart application fails; a failure must never restart the deadline.
      saved={...saved,code:data.code,expiresAt:data.expiresAt};persist();
      const latest=await cart();
      const applied=await setCodes([...codes(latest).filter(c=>!c.startsWith('SPQR5-')),data.code]);
      const accepted=applied.discount_codes?.some(d=>d.code===data.code && d.applicable===true);
      if(!accepted || data.expiresAt<=currentTime()) {active=null;render();return;}
      active=data;expiredHandled=false;if(showToast){dismissed=false;toastArmed=true;}
      document.dispatchEvent(new CustomEvent('cart:build'));
      for(const section of document.querySelectorAll('[data-spqr-quick-purchase]')) {
        const summary=section.querySelector('[data-spqr-next-ring]:not([hidden]) [data-spqr-added-summary]');
        if(summary) summary.textContent=section.dataset.productTitle+' added. Cart subtotal: '+new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:applied.currency}).format(applied.total_price/100)+'. Shipping and any taxes or duties are calculated at checkout.';
      }
      render();
      if(showToast) document.querySelector('[data-offer-announcement]').textContent='Your extra 10% discount is ready. Complete your order before the timer ends.';
    })().catch(()=>{active=null;render();}).finally(()=>{inFlight=null;});
    return inFlight;
  }
  document.addEventListener('spqr:cart-added',()=>start(true));
  document.addEventListener('product-form:submit:success',()=>start(true));
  document.addEventListener('ajaxProduct:added',event=>{if(event.detail?.product?.id || event.detail?.product?.items?.some(item=>item.id))start(true);});
  document.addEventListener('cart:updated',event=>{const c=event.detail?.cart;if(c?.item_count===0){active=null;render();}else if(c&&!active)start(true);}); // quantity changes (drawer/cart +) can also reach the 3-item offer
  document.addEventListener('visibilitychange',()=>{if(!document.hidden){render();if(saved.code&&!saved.expired)start();}});
  window.addEventListener('storage',event=>{if(event.key===storageKey){try{saved=JSON.parse(event.newValue)||saved;if(saved.expired){active=null;render();}else if(saved.code)start();}catch{}}});
  setInterval(render,1000);mount();
  if(saved.code&&!saved.expired)start();
})();
